/** KYC verification terms shown in the modal (legal copy). */

export const KYC_TERMS_TITLE = "KYC Verification – Terms & Conditions";

export const KYC_TERMS_INTRO =
  "By proceeding with KYC verification, you agree to the following:";

export type KycTermsSection = {
  heading: string;
  lead?: string;
  items: string[];
  footer?: string;
};

export const KYC_TERMS_SECTIONS: KycTermsSection[] = [
  {
    heading: "1. Consent",
    items: [
      "You consent to the collection, verification, and processing of your personal information for identity verification, fraud prevention, and regulatory compliance.",
      "You agree to be bound by these Terms and the platform’s Privacy Policy & T&Cs.",
      "You authorize verification through internal systems or third-party providers (e.g., credit bureaus, verification APIs).",
    ],
  },
  {
    heading: "2. Information & Documents Required",
    lead: "You agree to provide accurate and complete information, including but not limited to:",
    items: [
      "Full name, date of birth, and contact details.",
      "Government-issued ID (Aadhaar, PAN, Passport, Driving License, etc.).",
      "Any additional documents as required by applicable law or platform policies.",
    ],
    footer:
      "The document list is indicative and may change based on regulatory requirements.",
  },
  {
    heading: "3. Verification Process",
    items: [
      "KYC may be completed via OTP, document upload, video KYC, or physical verification.",
      "The platform may use third-party services to validate identity and documents.",
      "The platform reserves the right to request additional information or re-verification at any time.",
    ],
  },
  {
    heading: "4. User Obligations",
    lead: "You agree that:",
    items: [
      "All information submitted is true, accurate, and belongs to you.",
      "You will not impersonate another individual or entity.",
      "You will promptly update any changes to your KYC information.",
      "You will cooperate with any additional verification requests.",
    ],
    footer:
      "Failure to comply may result in restricted access or account suspension.",
  },
  {
    heading: "5. Transaction Monitoring & Compliance",
    items: [
      "All transactions may be monitored to detect suspicious or fraudulent activity.",
      "The platform may investigate and report activities as required under applicable laws.",
      "Accounts may be restricted during such investigations.",
    ],
  },
  {
    heading: "6. Right to Reject / Suspend",
    lead: "The platform reserves the right to:",
    items: [
      "Reject or delay KYC approval without providing reasons.",
      "Suspend or terminate accounts with incomplete, false, or unverifiable information.",
      "Block transactions deemed suspicious or non-compliant.",
    ],
  },
  {
    heading: "7. Data Usage & Sharing",
    lead: "You authorize the platform to:",
    items: [
      "Share your data with regulators, banks, credit bureaus, and verification partners.",
      "Use your information for fraud prevention, risk assessment, and compliance.",
      "Retain data as required under applicable laws.",
    ],
  },
  {
    heading: "8. Updates to KYC Terms",
    items: [
      "These terms may be updated periodically without prior notice.",
      "Continued use of the platform constitutes acceptance of revised terms.",
    ],
  },
];
